import { useState, useEffect } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import { InputField, NullableInput } from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"
import AsyncSelectField from "../../Shared/AsyncSelect"
import {location_categories_list} from "../../Shared/List";


const LocationForm = (props) => {
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [zoneOptions, setZoneOptions] = useState([]);
    const [villageOptions, setVillageOptions] = useState([]);
    const [lineOptions, setLineOptions] = useState([]);
    const [stationOptions, setStationOptions] = useState([]);
    const [rateOptions, setRateOptions] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [groupOptions, setGroupOptions] = useState([]);
    const [selectedVillage, setSelectedVillage] = useState(null);
    const [selectedStation, setSelectedStation] = useState(null);

    const [formData, setFormData] = useState({
        category: "",
        remark: "",
        contact_number: "",
        customer_id: "",
        zone_id: "",
        village_id: "",
        line_id: null,
        station_id: "",
        rate_id: "",
        group_id: "",
        date: new Date().toISOString().slice(0, 10),
        description: "",
    });
    const {category, remark, contact_number, customer_id, zone_id, village_id, line_id, station_id, rate_id, group_id, date, description} = formData

    const navigate = useNavigate()
    useEffect(() => {
        
        if (selectedVillage?.value) {
            loadOptions('village-zones', '', setZoneOptions, selectedVillage.value).then((response) => {
                const zones = [{id: null, key: "", name: "-- please select zone --"}]
                response.map((zone => {
                    zones.push({
                        id: zone.value,
                        key: zone.public_id,
                        name: zone.label
                    })
                }))
                setZoneOptions(zones);
            });
        }

        setCategoryOptions(location_categories_list.map(category => ({
            id: category.id, 
            key: category.key, 
            name: category.name
        })));

        if (selectedStation?.value) {
            loadOptions('station-lines', '', setLineOptions, null, selectedStation.value).then((response) => {
                const lines = [{id: null, key: "", name: "-- please select line --"}]
                response.map((line => {
                    lines.push({
                        id: line.value,
                        key: line.public_id,
                        name: line.label
                    })
                }))
                setLineOptions(lines);
            });
        }

    }, [selectedVillage, selectedStation]);

    const loadOptions = async (url, query, setOptions, villageId=null, stationId=null) => {
        try {
            const params = { q: query };
            
            if (url === 'village-zones' && villageId) {
                params.village_id = villageId; // Send village_id only when loading zones
            }

            if (url === 'station-lines' && stationId) {
                params.station_id = stationId; // Send station_id only when loading zones
            }

            const response = await Server.get(`/options/${url}`, { params });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
        
        // change zoneOptions when village is selected
        if (e.target.name === 'village_id'){
            setSelectedVillage(e.target);
        }

        // change lineOptions when station is selected
        if (e.target.name === 'station_id'){
            setSelectedStation(e.target);
        }
    }

    const onSubmit = (e) => {
        e.preventDefault()
        //find category name with its index
        const category_name = location_categories_list[formData?.category - 1]?.name || 'Mulkiile'
        const payload = {category: category_name, remark, contact_number, customer_id, zone_id, line_id: line_id, rate_id, group_id, date, description}
        addLocation(payload)
    }
    
    // add location
    const addLocation = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/locations/', payload)
            if (response.status === 201){
                toast.success('Successfully created')
                navigate('/locations-serverside')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                setErrors(error.response.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Create New Location</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="customer_id"
                                label="Customer"
                                value={customer_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('customers', query, setCustomerOptions)}
                                options={customerOptions}
                                placeholder="Start typing to search..."
                                error={errors.customer_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Remark"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Contact"
                                name="contact_number"
                                type="text"
                                label="Location Contact"
                                value={contact_number}
                                onChange={onChange}
                                error={errors.contact_number}
                            />
                        </div>
                        <div className="col-md-2">
                            <SelectField
                                name="category"
                                label="Category"
                                value={parseInt(category)}
                                options={categoryOptions}
                                onChange={onChange}
                                error={errors.category}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <AsyncSelectField
                                name="group_id"
                                label="Group"
                                value={group_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('location-groups', query, setGroupOptions)}
                                options={groupOptions}
                                placeholder="Start typing to search..."
                                error={errors.group_id}
                            />
                        </div> 
                        <div className="col-md-3">
                            <AsyncSelectField
                                name="rate_id"
                                label="Rate"
                                value={rate_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('rates', query, setRateOptions)}
                                options={rateOptions}
                                placeholder="Start typing to search..."
                                error={errors.rate_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <AsyncSelectField
                                name="village_id"
                                label="Village"
                                value={village_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('villages', query, setVillageOptions)}
                                options={villageOptions}
                                placeholder="Start typing to search..."
                                error={errors.village_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <SelectField
                                name="zone_id"
                                label="Zone"
                                value={parseInt(zone_id)}
                                options={zoneOptions}
                                onChange={onChange}
                                error={errors.zone_id}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="station_id"
                                label="Station"
                                value={station_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('stations', query, setStationOptions)}
                                options={stationOptions}
                                placeholder="Start typing to search..."
                                error={errors.station_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <SelectField
                                name="line_id"
                                label="Line"
                                value={parseInt(line_id)}
                                options={lineOptions}
                                onChange={onChange}
                                error={errors.line_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <NullableInput
                                placeholder="Location Detail"
                                name="description"
                                type="text"
                                label="Description (Optional)"
                                value={description}
                                onChange={onChange}
                                error={errors.description}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Location" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default LocationForm
